<template>
    <v-container class='pa-0'>
        <h3 class="mb-3">Send Feedback</h3>
        <hr class="thick" />
        <v-layout row wrap>
            <v-flex sm12>
                <v-form ref="newFeedbackForm" v-model="form.valid">
                    <v-textarea class='mt-4' label="Message*" :rules='form.message' placeholder="Please provide your message here" v-model="feedback.message" outline></v-textarea>
                    <v-switch
                    :label="`Request Follow-up? ${feedback.followup ? 'Yes': 'No' }`"
                    v-model="feedback.followup"
                    color="secondary"
                    class="mt-2 mb-0 pb-0"></v-switch>
                    <v-layout row nowrap>
                    <v-flex shrink>
                      <v-btn color="primary" @click.enter="submitFeedback" class='ml-0'>Submit Feedback</v-btn>
                      </v-flex>
                      <v-flex shrink>
                      <v-btn @click='$router.go(-1)' class="ml-1" flat outline>Cancel and Close</v-btn>
                    </v-flex>
                    </v-layout>
                </v-form>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>

export default {
  components: {
  },
  data() {
    return {
      loading: false,
      from_path: '',
      feedback: { followup: false },
      form: {
        valid: false,
        message: [
          v =>
            !!v ||
            "Please include your feedback message"
        ]
      }
    };
  },
  methods: {
    submitFeedback() {
      if (this.$refs.newFeedbackForm.validate()) {
        const formData = {
          user_id: this.$auth.user().id, // only for debugging
          url: this.from_path,
          message: this.feedback.message,
          follow_up_requested: this.feedback.followup
        };
        this.$http.post("feedback", formData).then(
          response => {
            this.$store.commit("updateMessage", {
              message: "Feedback submitted.",
              snackbar: true
            });
            this.$router.go(-1);
          },
          response => {
            console.log("Error submitting feedback");
          }
        );
      } else {
        this.$store.commit("updateMessage", {
          message: "Nice try, but some required information is missing. Give it another go!",
          snackbar: true
        });
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // set the path user was on before feedback
      vm.from_path = from.path
    });
  }
};
</script>
